<div class="ibox detailed-view-ibox">
    <div class="detailed-view-header">
        <div class="col-sm-9">
            <span>Resident</span>
        </div>
        <div class="col-sm-3"
             *ngIf="parent.suiteData && parent.directoryService.account.canUpdate('bldn', parent.suiteData.building.id)">
            <button type="button" class="btn btn-w-m btn-primary pull-right" (click)="create()">
                <i class="fa fa-plus-circle"></i> Add Resident
            </button>
        </div>
    </div>

    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form *ngIf="data"
                  #form="ngForm"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <!--  ** ROLE **  -->
                <role-field [ngModel]="data.suiteUser[0].role"
                            name="role"
                            [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                            (update)="update({role: form.value.role});updateUserRoleInList(data.id, form.value.role)">
                </role-field>
                <span *ngIf="directoryService.dateIsLaterThanCurrent(data.suiteUser[0].occupancyDate)"
                      class="label resident-label">
                    Move In
                </span>
                <span *ngIf="directoryService.dateIsLaterThanCurrent(data.suiteUser[0].moveOutDate)"
                      class="label resident-label">
                    Move Out
                </span>
                <span *ngIf="directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                      class="label archived-item">
                    Archived
                </span>

                <div class="row m-t-md m-b-md">
                    <div class="col-md-2 avatar-box" [ngClass]="{'loading': spinnerAvatar}">
                        <label class="circle-logo">
                            <input class="hidden"
                                   type="file"
                                   [disabled]="avatarUploadDisabled || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                   (change)="changeAvatar($event)"
                                   accept="image/jpeg, image/png">
                            <img [src]="data.photo || 'assets/img/user-icon.png'"/>

                            <spinner [spinnerShow]="spinnerAvatar"></spinner>
                        </label>
                        <label *ngIf="data.photo" class="delete-avatar" (click)="removeAvatar($event)">
                            <i class="fa fa-trash"></i>
                        </label>
                        <label *ngIf="data.isCanEdit && !directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                               class="delete-avatar clickable camera"
                               (click)="takeImageFromWebcam($event)">
                            <i class="fa fa-camera" aria-hidden="true"></i>
                        </label>
                    </div>

                    <div class="col-md-10 profile-main-info">
                        <!--  ** FULLNAME **  -->
                        <input-field [ngModel]="data.fullName"
                                     name="fullName"
                                     [required]="true"
                                     [class]="'strong full-name-field'"
                                     [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                     (update)="update({fullName: form.value.fullName});
                                               updateNameInList('residentsList', data.id, 'fullName',form.value.fullName)">
                        </input-field>

                        <!--  ** PRIMARY PHONE **  -->
                        <div *ngIf="getPrimaryPhone(phoneField.value)">
                            <div class="row">
                                <div class="dv-value col-sm-12">
                                    <i class="fa fa-phone  m-r-sm"> </i>
                                    <span> {{ getPrimaryPhone(phoneField.value) }} </span>
                                </div>
                            </div>
                        </div>

                        <!--  ** EMAIL **  -->
                        <resident-email-field [ngModel]="data.email"
                                              [value]="data.email"
                                              name="email"
                                              [icon]="'fa fa-envelope'"
                                              [invalidEmail]="!data.isValidEmail"
                                              [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                              (update)="update({email: form.value.email})"
                                              [canSetAsValid]="data.isCanEdit"
                                              (setAsValid)="update({isValidEmail: 1})"
                        >
                        </resident-email-field>
                    </div>
                </div>

                <div class="btn-group"
                     *ngIf="data.id &&
                            (data.isCanEdit || data.isCanDelete || data.maxTvUser ||
                             (!directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate) && (directoryService.account.canUpdate('amenity') || directoryService.account.canUpdate('parking_pass'))))">
                    <a data-toggle="dropdown" class="btn btn-default btn-sm dropdown-toggle">
                        Actions <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu multi-level">
                        <li class="dropdown-submenu"
                            *ngIf="data.isCanEdit &&
                                   (data.email || (directoryService.getCellPhones(data.phones).length > 0 && directoryService.showSendSms())) &&
                                   !directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)">
                            <a>Send</a>
                            <ul class="dropdown-menu">
                                <li *ngIf="data.email">
                                    <a (click)="sendInvitation(false)">Send Message</a>
                                </li>
                                <li *ngIf="data.isCanEdit && directoryService.getCellPhones(data.phones).length > 0 &&
                                           directoryService.showSendSms()">
                                    <a (click)="directoryService.sendSms(data)">Send SMS</a>
                                </li>
                                <li *ngIf="data.email && !data.maxTvUser">
                                    <a (click)="sendInvitation(true)">
                                        <span *ngIf="data.maxTvUser">Resend</span><span *ngIf="!data.maxTvUser">Send</span> Invitation
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <li *ngIf="data && !directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)
                                   && (directoryService.account.canUpdate('amenity') || directoryService.account.canUpdate('parking_pass'))"
                            class="dropdown-submenu">
                            <a tabindex="-1">Add</a>
                            <ul class="dropdown-menu">
                                <li *ngIf="directoryService.account.canUpdate('amenity')">
                                    <a (click)="bookAmenityForResident(data)">Add Amenity Booking</a>
                                </li>
                                <li *ngIf="directoryService.account.canUpdate('parking_pass')">
                                    <a (click)="createParkingPassForResident(data)">Add Parking Pass</a>
                                </li>
                            </ul>
                        </li>
                        <li class="dropdown-submenu"
                            *ngIf="data && !directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)">
                            <a tabindex="-1">Instructions</a>
                            <ul class="dropdown-menu">
                                <li><a (click)="addInstructions('entry')">Entry Instructions</a></li>
                                <li><a (click)="addInstructions('vacation')">Vacation Notice</a></li>
                            </ul>
                        </li>
                        <li *ngIf="data.maxTvUser && !directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)">
                            <a (click)="resetPassword(data)">Reset Password</a>
                        </li>
                        <li *ngIf="data.isCanDelete &&
                                   (!data.suiteUser[0].moveOutDate || directoryService.dateIsLaterThanCurrent(data.suiteUser[0].moveOutDate)) &&
                                   !directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)">
                            <a (click)="moveResidentOut(data.suiteUser[0])">Move Out</a>
                        </li>
                        <li (click)="restore()"
                            *ngIf="data.isCanEdit && directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)">
                            <a>Restore</a>
                        </li>
                    </ul>
                </div>

                <hr *ngIf="directoryService.selectedResidentInstructions.length > 0">

                <div class="row m-b-xs" *ngIf="directoryService.selectedResidentInstructions.length > 0">
                    <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                        Instructions
                    </div>

                    <div class="dv-value col-sm-9 mtv-primary-color clickable text-right"
                         *ngIf="!showInstructionsHistory && numberOfCurrentInstructions() < directoryService.selectedResidentInstructions.length"
                         (click)="showInstructionsHistoryTrigger(true)">
                        + Show Instructions History
                    </div>

                    <div class="dv-value col-sm-9 mtv-primary-color clickable text-right"
                         *ngIf="showInstructionsHistory || numberOfCurrentInstructions() == directoryService.selectedResidentInstructions.length"
                         (click)="showInstructionsHistoryTrigger(false)">
                        - Hide Instructions History
                    </div>
                </div>

                <div class="row m-b-xs resident-instructions-row"
                     *ngFor="let instruction of directoryService.selectedResidentInstructions; let index = index;"
                     [ngStyle]="{'display': instruction.visible ? 'block' : 'none'}">
                    <div class="col-sm-12 m-b-xs">
                        <label>{{instruction.subject}}</label>
                        <pre>{{instruction.text}}</pre>
                    </div>
                    <div class="dv-label col-sm-12">
                        <span class="same-label-width label label-{{instruction.status}} m-r-sm">{{instruction.status}}</span>
                        {{instruction.startDate | date:'dd.MM.yyyy'}} <span *ngIf="instruction.endDate"> - {{instruction.endDate | date:'dd.MM.yyyy'}}</span>
                        <i *ngIf="!directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                           class="fa fa-trash pull-right"
                           (click)="directoryService.deleteResidentInstruction(instruction)">
                        </i>
                        <i *ngIf="!directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                           (click)="editInstruction(instruction)"
                           class="fa fa-pencil pull-right">
                        </i>
                    </div>
                </div>

                <hr>
                <!--  ** ALTERNATIVE EMAILS **  -->
                <resident-alternative-emails-field
                    name="alternativeEmails"
                    [ngModel]="data.alternativeEmails"
                    [value]="data.alternativeEmails"
                    [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.moveOutDate)"
                    (update)="onSubmit({alternativeEmails: form.value.alternativeEmails})">
                </resident-alternative-emails-field>

                <hr>


                <hr *ngIf="directoryService.selectedResidentInstructions.length > 0">

                <!--PHONES-->
                <phone-field #phoneField
                             [ngModel]="data.phones"
                             name="phones"
                             [userId]="data.id"
                             [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                             (update)="update({phones: form.value.phones})"
                             (reset)="resetPhones($event)">
                </phone-field>

                <hr>

                <!--ADDRESS-->
                <address-field [multiple]="true"
                               [ngModel]="data.addresses"
                               name="addresses"
                               [value]="data.addresses"
                               [userId]="data.id"
                               [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                               (update)="update({addresses: form.value.addresses})"
                               (reset)="resetAddress($event)">
                </address-field>

                <hr>

                <!--  ** Move In Date **  -->
                <datetime-field name="occupancyDate"
                                [classLabel]="'dv-label col-sm-3 strong'"
                                [classValueBox]="'dv-value col-sm-9'"
                                [classValueEditBox]="'dv-value-edit col-sm-9'"
                                [title]="'Move In Date'"
                                [ngModel]="data.suiteUser[0].occupancyDate"
                                [value]="data.suiteUser[0].occupancyDate"
                                [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                (update)="update({occupancyDate: convertDate(form.value.occupancyDate)})">
                </datetime-field>

                <!--  ** Move Out Date **  -->
                <datetime-field name="moveOutDate"
                                [classLabel]="'dv-label col-sm-3 strong'"
                                [classValueBox]="'dv-value col-sm-9'"
                                [classValueEditBox]="'dv-value-edit col-sm-9'"
                                [title]="'Move Out Date'"
                                [ngModel]="data.suiteUser[0].moveOutDate"
                                [value]="data.suiteUser[0].moveOutDate"
                                [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                (update)="update({moveOutDate: convertDate(form.value.moveOutDate)})">
                </datetime-field>

                <hr>

                <!--  ** DATE OF BIRTH **  -->
                <!--<datetime-field name="dateOfBirth"
                                [classLabel]="'dv-label col-sm-3 strong'"
                                [classValueBox]="'dv-value col-sm-9'"
                                [classValueEditBox]="'dv-value-edit col-sm-9'"
                                [title]="'DOB'"
                                [ngModel]="data.dateOfBirth"
                                [value]="data.dateOfBirth"
                                [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                (update)="update({dateOfBirth: convertDate(form.value.dateOfBirth)})">
                </datetime-field>

                <hr>-->

                <!--GROUPS-->
                <groups-field name="groups"
                              [ngModel]="data.groups"
                              [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                              (update)="update({groups: form.value.groups})">
                </groups-field>

                <hr>

                <div class="row m-b-xs">
                    <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                        Active
                    </div>

                    <div class="dv-value col-sm-9">
                        <span *ngIf="data.maxTvUser">
                            <i class="icon-check"></i>
                            <span class="signedLabel">Active</span>
                        </span>
                        <span *ngIf="!data.maxTvUser && data.isInvited">
                            <i><img src="../../../../../assets/img/pending.png"></i>
                            Invited
                        </span>
                        <span *ngIf="!data.maxTvUser && !data.isInvited">
                            <i class="icon-close"></i>
                            <span class="signedLabel">Not Active</span>
                        </span>
                    </div>
                </div>

                <hr *ngIf="directoryService.currentCorporationSettings.useEmailWaiver ||
                           directoryService.currentCorporationSettings.useParcelsWaiver ||
                           directoryService.currentCorporationSettings.useKeyWaiver">

                <!--  ** Waiver Signed **  -->
                <boolean-field *ngIf="directoryService.currentCorporationSettings.useEmailWaiver"
                               [ngModel]="data.emailWaiverSigned"
                               name="emailWaiverSigned"
                               [title]="'Waiver Signed'"
                               [valueTitle]="'Electronic Notifications Agreement'"
                               [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                               (update)="update({emailWaiverSigned: form.value.emailWaiverSigned})">
                </boolean-field>

                <boolean-field *ngIf="directoryService.currentCorporationSettings.useParcelsWaiver"
                               [ngModel]="data.parcelWaiverSigned"
                               name="parcelWaiverSigned"
                               [title]="!directoryService.currentCorporationSettings.useEmailWaiver ? 'Waiver Signed' : ' '"
                               [valueTitle]="'Parcels'"
                               [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                               (update)="update({parcelWaiverSigned: form.value.parcelWaiverSigned})">
                </boolean-field>

                <boolean-field *ngIf="directoryService.currentCorporationSettings.useKeyWaiver"
                               [ngModel]="data.keyWaiverSigned"
                               name="keyWaiverSigned"
                               [title]="!directoryService.currentCorporationSettings.useEmailWaiver &&
                                        !directoryService.currentCorporationSettings.useParcelsWaiver ? 'Waiver Signed' : ' '"
                               [valueTitle]="'Keys'"
                               [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                               (update)="update({keyWaiverSigned: form.value.keyWaiverSigned})">
                </boolean-field>

                <hr>

                <boolean-field *ngIf="form.value.role == 'owner_on' || form.value.role == 'owner_off'"
                               name="ownerInformationFormReceived"
                               [title]="'Owner Info'"
                               [valueTitle]="'Owner Information Form Received'"
                               [ngModel]="data.ownerInformationFormReceived"
                               [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                               (update)="update({ownerInformationFormReceived: form.value.ownerInformationFormReceived})">
                </boolean-field>

                <boolean-field *ngIf="form.value.role == 'rent'"
                               name="leaseReceived"
                               [title]="'Tenant Info'"
                               [valueTitle]="'Lease Received'"
                               [ngModel]="data.leaseReceived"
                               [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                               (update)="update({leaseReceived: form.value.leaseReceived})">
                </boolean-field>

                <boolean-field *ngIf="form.value.role == 'rent'"
                               name="tenantInformationFormReceived"
                               [title]="' '"
                               [valueTitle]="'Information Form Received'"
                               [ngModel]="data.tenantInformationFormReceived"
                               [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                               (update)="update({tenantInformationFormReceived: form.value.tenantInformationFormReceived})">
                </boolean-field>

                <boolean-field *ngIf="form.value.role == 'rent'"
                               name="primaryLeaseHolder"
                               [title]="' '"
                               [valueTitle]="'Primary Lease Holder'"
                               [ngModel]="data.primaryLeaseHolder"
                               [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                               (update)="update({primaryLeaseHolder: form.value.primaryLeaseHolder})">
                </boolean-field>

                <!--  ** DATE OF BIRTH **  -->
                <datetime-field *ngIf="form.value.role == 'rent'"
                                name="leaseStartDate"
                                [ngModel]="data.leaseStartDate"
                                [title]="'Lease Start Date'"
                                [value]="data.leaseStartDate"
                                [classLabel]="'dv-label col-sm-3 strong'"
                                [classValueBox]="'dv-value col-sm-9'"
                                [classValueEditBox]="'dv-value-edit col-sm-9'"
                                [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                (update)="update({leaseStartDate: form.value.leaseStartDate})">
                </datetime-field>

                <hr *ngIf="form.value.role == 'owner_on' || form.value.role == 'owner_off' || form.value.role == 'rent'">

                <div class="row m-b-xs">
                    <div class="dv-label col-sm-3 strong" data-toggle="tooltip" data-placement="top">
                        Consent
                    </div>

                    <div class="dv-value col-sm-3">
                        <i *ngIf="data.consent && data.consent.isSigned == 1" class="icon-check"></i>
                        <i *ngIf="!data.consent || data.consent.isSigned == 0" class="icon-close"></i>
                    </div>

                    <div class="dv-value col-sm-6" *ngIf="!directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)">
                        <i *ngIf="data.consent && data.consent.isSigned == 1 && data.consent.pathToPdf"
                           class="fa fa-file-pdf-o mtv-primary-color"
                           aria-hidden="true"
                           style="cursor: pointer; font-size: 18px;"
                           (click)="directoryService.openPdfInNewTab(data.consent.pathToPdf)"></i>
                        <i *ngIf="!data.consent || data.consent.isSigned == 0"
                           class="icon-plus pull-right"
                           (click)="clickConsentInput()"></i>
                        <i *ngIf="data.consent && data.consent.isSigned == 1"
                           (click)="uploadConsent(data.id, null, false)"
                           class="fa fa-trash pull-right"></i>
                        <input id="fileInput" name="fileInput" type="file" class="hidden" (change)="onFileInput($event)">
                    </div>
                </div>

                <hr>

                <!--  ** EMERGENCY CONTACT **  -->
                <emergency-contacts-field *ngIf="!isSuperAdmin"
                                          [ngModel]="data.emergencyContacts"
                                          name="emergencyContacts"
                                          [title]="'Emergency Contact'"
                                          [objectId]="data.suiteUser[0]?.suite?.id"
                                          [propertyName]="'suite'"
                                          (update)="update({emergencyContacts: form.value.emergencyContacts})"
                                          [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)">
                </emergency-contacts-field>

                <!--  ** EMERGENCY ASSISTANT NOTES **  -->
                <input-field [ngModel]="data.emergencyAssistantNotes"
                             name="emergencyAssistantNotes"
                             [title]="'Emerg. Notes'"
                             [tooltipText]="'Emergency Assistant Notes'"
                             [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                             (update)="update({emergencyAssistantNotes: form.value.emergencyAssistantNotes})">
                </input-field>

                <!--  ** DISABILITIES **  -->
                <textarea-field name="disabilities"
                                [ngModel]="data.disabilities"
                                [maxLength]="255"
                                [title]="'Disabilities'"
                                [tooltipText]="'Disabilities'"
                                [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                (update)="update({disabilities: form.value.disabilities})">
                </textarea-field>

                <!--** note ** -->
                <textarea-field [ngModel]="data.note"
                                [maxLength]="255"
                                name="note"
                                [tooltipText]="'Note'"
                                [title]="'Note'"
                                [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                (update)="update({note: form.value.note})">
                </textarea-field>

                <hr>

                <!--** Buzz ** -->
                <directory-unit-array-input-field [ngModel]="data.buzzFields"
                                                  name="buzz"
                                                  [tooltipText]="'Buzz'"
                                                  [title]="'Buzz'"
                                                  [userId]="data.id"
                                                  [suiteUsers]="[{user:{id: data.id, fullName: data.fullName}}]"
                                                  [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                                  (update)="arrayFieldsSubmit('buzzFields', {buzzFields: form.value.buzz})">
                </directory-unit-array-input-field>

                <!--** Key Code ** -->
                <directory-unit-array-input-field [ngModel]="data.keyCodeFields"
                                                  name="keyCode"
                                                  [tooltipText]="'Key Code'"
                                                  [title]="'Key Code'"
                                                  [userId]="data.id"
                                                  [suiteUsers]="[{user: {id: data.id, fullName: data.fullName}}]"
                                                  [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                                  (update)="arrayFieldsSubmit('keyCodeFields', {keyCodeFields: form.value.keyCode})">
                </directory-unit-array-input-field>

                <!--** Key Fob ** -->
                <directory-unit-array-input-field [ngModel]="data.keyFobFields"
                                                  name="keyFob"
                                                  [tooltipText]="'Key Fob'"
                                                  [title]="'Key Fob'"
                                                  [userId]="data.id"
                                                  [suiteUsers]="[{user:{id: data.id, fullName: data.fullName}}]"
                                                  [noEdit]="!data.isCanEdit || directoryService.dateIsEarlierThanCurrent(data.suiteUser[0].moveOutDate)"
                                                  (update)="arrayFieldsSubmit('keyFobFields', {keyFobFields: form.value.keyFob})">
                </directory-unit-array-input-field>

                <hr>

                <div class="row">
                    <div class="col-md-3 dv-label">
                        <label>Vehicles</label>
                    </div>
                    <div class="col-md-9 dv-value">
                        <div *ngIf="data.suiteUser[0].suite.vehicles.length < 1">-</div>
                        <div *ngFor="let vehicle of data.suiteUser[0].suite.vehicles; let last = last;">
                            {{vehicle.color}} {{vehicle.brand}} {{vehicle.model}} {{vehicle.year}} {{vehicle.licensePlate}}
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3 dv-label">
                        <label>Pets</label>
                    </div>
                    <div class="col-md-9 dv-value">
                        <div *ngIf="data.suiteUser[0].suite.pet.length < 1">-</div>
                        <div *ngFor="let pet of data.suiteUser[0].suite.pet; let last = last;">
                            {{pet.petType ? pet.petType.name : ''}} {{pet.name}}
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <spinner [spinnerShow]="parent.spinnerShow"></spinner>
</div>

<div class="boxForModal" *ngIf="isCreateModal && parent.suiteData">
    <resident-create [closeTrigger]="hideModal"
                     (onPopupClose)="hideModal()"
                     [buildingId]="parent.suiteData.building.id"
                     [suiteId]="parent.suiteData.id"
                     [inDirectoryItemView]="true">
    </resident-create>
</div>
<move-out-modal *ngIf="directoryService.showMoveOutModal"></move-out-modal>
<send-invitation-modal *ngIf="directoryService.showSendInvitationModal"></send-invitation-modal>
<reset-password-modal *ngIf="directoryService.showResetPasswordModal"></reset-password-modal>
<add-instructions-modal *ngIf="directoryService.showAddInstructionsModal"></add-instructions-modal>
<amenities-modal *ngIf="amenitiesService.isAmenityModalShow"></amenities-modal>
<parking-pass-modal *ngIf="parkingPassService.isParkingPassModalShow"></parking-pass-modal>
<capture-image-modal *ngIf="directoryService.showImageCaptureModal"
                     (onClose)="directoryService.onImageCaptureModalClose($event)">
</capture-image-modal>
<send-sms-modal *ngIf="directoryService.showSmsModal"></send-sms-modal>



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/residents/residents.template.html